
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global.js'
import $ from 'jquery'
export default {
components: {
Flexbox,
FlexboxItem,
XImg,
XTextarea,
XButton,
Group,
loadPage,
$
},
data (){
return {
srcs:'',
show_1:false,
sellerNames:'',
dates:'',
phones:'',
addres:'',
sloves:'',
typePersson:'',
m1:true,
m2:false
}
},
beforeMount(){
this.show_1 = true;
let serviceId = this.$router.history.current.query.serviceID;
let url = global.host + 'conven/findByServiceId/'+ serviceId;
console.log()
this.$http.get(url).then(function(res){
console.log('电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型电话类型')
console.log(res)
this.srcs = res.body.result.serviceIcon;
this.sellerNames = res.body.result.comnname;
this.dates = res.body.result.createDate;
this.phones = res.body.result.telePhone;
this.addres = res.body.result.serviceAddr;
this.sloves = res.body.result.content;
$("#mtext").html(this.sloves);
this.typePersson = res.body.result.modulename
this.show_1 = false;
},function(error){
console.log(error)
})
},
methods:{
colects(){
if(this.m1 == true){
this.m1 = false;
this.m2 = true;
}else{
this.m1 = true;
this.m2 = false;
}

}
}
}



// WEBPACK FOOTER //
// ./src/components/convenientComponents/convenientSellDetail.vue